const CONTENT_TYPES = {
  application_json: 'application/json',
  multipart_formdata: 'multipart/form-data',
  accounts_profile: 'application/vnd.carry1st.accounts.profile+json',
  accounts_adminUser: 'application/vnd.carry1st.accounts.adminuser+json',
  accounts_permission: 'application/vnd.carry1st.accounts.permission+json',
  accounts_role: 'application/vnd.carry1st.accounts.role+json',
  accounts_customer: 'application/vnd.carry1st.accounts.customer+json',
  accounts_device: 'application/vnd.carry1st.accounts.device+json',
  accounts_authentication: 'application/vnd.carry1st.accounts.authentication+json',
  data_analytics: 'application/vnd.carry1st.data.analytics+json',
  daily_deals: 'application/vnd.carry1st.products.dailydeal+json',
  settings_appversion: 'application/vnd.carry1st.settings.appversion+json',
  settings_setting: 'application/vnd.carry1st.settings.setting+json',
  settings_otpmethod: 'application/vnd.carry1st.settings.otpmethod+json',
  settings_cache: 'application/vnd.carry1st.settings.cache+json',
  settings_otp_country: 'application/vnd.carry1st.settings.otpcountry+json',
  payments_availablechannel: 'application/vnd.carry1st.payments.availablechannel+json',
  payments_blockedcard: 'application/vnd.carry1st.payments.blockedcard+json',
  payments_blockedpaymentdetail: 'application/vnd.carry1st.payments.blockedpaymentdetail+json',
  payments_paymentchannel: 'application/vnd.carry1st.payments.paymentchannel+json',
  payments_classification: 'application/vnd.carry1st.payments.classification+json',
  payments_paymentoptionbin: 'application/vnd.carry1st.payments.paymentoptionbin+json',
  payments_paymentoptionpaypalpayer: 'application/vnd.carry1st.payments.paymentoptionpaypalpayer+json',
  payments_paymentoption: 'application/vnd.carry1st.payments.paymentoption+json',
  payments_paymentformtype: 'application/vnd.carry1st.payments.paymentformtype+json',
  payments_paymentmethodtype: 'application/vnd.carry1st.payments.paymentmethodtype+json',
  payments_payoutchannel: 'application/vnd.carry1st.payments.payoutchannel+json',
  payments_payout_transaction: 'application/vnd.carry1st.payments.payout.transaction+json',
  payments_pii: 'application/vnd.carry1st.payments.pii+json',
  payments_fraudtrigger: 'application/vnd.carry1st.payments.fraudtrigger+json',
  payments_tax: 'application/vnd.carry1st.payments.tax+json',
  payments_transaction: 'application/vnd.carry1st.payments.transaction+json',
  payments_payment: 'application/vnd.carry1st.payments.payment+json',
  cms_banner: 'application/vnd.carry1st.cms.banner+json',
  cms_content: 'application/vnd.carry1st.cms.content+json',
  cms_faq: 'application/vnd.carry1st.cms.faq+json',
  cms_proposition: 'application/vnd.carry1st.cms.proposition+json',
  order_order: 'application/vnd.carry1st.order.order+json',
  partners: 'application/vnd.carry1st.payments.partner+json',
  partners_contact: 'application/vnd.carry1st.payments.partnercontact+json',
  partners_settings: 'application/vnd.carry1st.payments.partnersettings+json',
  partners_credentials: 'application/vnd.carry1st.payments.partnercredential+json',
  partners_channels: 'application/vnd.carry1st.payments.paymentchannel+json',
  partners_webhooks: 'application/vnd.carry1st.payments.partnerpaymentwebhook+json',
  products_country: 'application/vnd.carry1st.products.country+json',
  products_productmetatag: 'application/vnd.carry1st.products.productmetatag+json',
  products_categorymetatag: 'application/vnd.carry1st.products.categorymetatag+json', // Added this line
  products_dynamic_searchtag: 'application/vnd.carry1st.products.dynamic.searchtag+json',
  products_productterm: 'application/vnd.carry1st.products.productterm+json',
  products_currency: 'application/vnd.carry1st.products.currency+json',
  products_exchangerate: 'application/vnd.carry1st.products.exchangerate+json',
  products_bundle: 'application/vnd.carry1st.products.bundle+json',
  products_productcategory: 'application/vnd.carry1st.products.productcategory+json',
  products_productmeta: 'application/vnd.carry1st.products.productmeta+json',
  products_product: 'application/vnd.carry1st.products.product+json',
  products_fee: 'application/vnd.carry1st.products.fee+json',
  products_provider: 'application/vnd.carry1st.products.provider+json',
  fulfilment_channel: 'application/vnd.carry1st.order.fulfilmentchannel+json',
  fulfilment_transaction: 'application/vnd.carry1st.order.fulfilmenttransaction+json',
  gems_transaction: 'application/vnd.carry1st.gems.transaction+json',
  gems_customer: 'application/vnd.carry1st.gems.customer+json',
  gems_fee: 'application/vnd.carry1st.gems.fee+json',
  vip_customer: 'application/vnd.carry1st.vip.customer+json',
  vip_challenge: 'application/vnd.carry1st.vip.challenge+json',
  vip_level: 'application/vnd.carry1st.vip.level+json',
  vip_levelhistory: 'application/vnd.carry1st.vip.levelhistory+json',
  vip_points: 'application/vnd.carry1st.vip.points+json',
  vip_promo: 'application/vnd.carry1st.vip.promo+json',
  vip_transaction: 'application/vnd.carry1st.vip.transaction+json',
  discountpoints_transaction: 'application/vnd.carry1st.discountpoints.transaction+json',
  discountpoints_customer: 'application/vnd.carry1st.discountpoints.customer+json',
  discountpoints_scheduler: 'application/vnd.carry1st.discountpoints.scheduler+json',
  promos_promocode: 'application/vnd.carry1st.promos.promocode+json',
  promos_promo: 'application/vnd.carry1st.promos.promo+json',
  promos_promocodegroup: 'application/vnd.carry1st.promos.promocodegroup+json',
  stock_inventory: 'application/vnd.carry1st.stock.inventory+json',
  stock_product: 'application/vnd.carry1st.stock.product+json',
  stock_provider: 'application/vnd.carry1st.stock.provider+json',
  products_scheduler_bluelabel: 'application/vnd.carry1st.products.scheduler.bluelabel+json',
  products_scheduler_stellr: 'application/vnd.carry1st.products.scheduler.stellr+json',
  payments_scheduler_paystack: 'application/vnd.carry1st.payments.scheduler.paystack+json',
  products_scheduler_primeairtime: 'application/vnd.carry1st.products.scheduler.primeairtime+json',
  products_scheduler_razergold: 'application/vnd.carry1st.products.scheduler.razergold+json',
  payments_scheduler_cellulant: 'application/vnd.carry1st.payments.scheduler.cellulant+json',
  products_scheduler_vas2netsdata: 'application/vnd.carry1st.products.scheduler.vas2netsdata+json',
  products_scheduler_seagmcard: 'application/vnd.carry1st.products.scheduler.seagmcard+json',
  products_scheduler_seagmdirect: 'application/vnd.carry1st.products.scheduler.seagmdirect+json',
  payments_scheduler_paga_ussdbank: 'application/vnd.carry1st.payments.scheduler.paga.ussdbank+json',
  products_scheduler_dailydeals: 'application/vnd.carry1st.products.scheduler.dailydeal+json',
  social_proof: 'application/vnd.carry1st.products.socialproof+json'
};

export default CONTENT_TYPES;
